// src/store/mapStore.js
// Map UI state: active mode, selected overlay, active pin, radar toggle.
// Not persisted — map always opens in default state.
// The map hook (useMap) reads from here; the mode strip writes to it.

import { create } from 'zustand';

export const useMapStore = create((set) => ({
  // Which map mode is active
  mapMode:      'situation',   // 'situation' | 'flood' | 'radar' | 'shelters' | 'gas' | 'evac'

  // Filter within situation mode
  activeFilter: 'All',

  // Currently selected marker (shown in detail sheet)
  activePin:    null,          // { type, id, lat, lon, ...data }

  // User's GPS location (set by useGPS after locate())
  userLat:      null,
  userLon:      null,
  userAccuracy: null,

  // Overlay toggles
  radarVisible: true,

  // ── Actions ───────────────────────────────────────────────────
  setMapMode: (mode) => set({
    mapMode:      mode,
    activeFilter: 'All',
    activePin:    null,
  }),

  setFilter:       (filter)          => set({ activeFilter: filter }),
  setActivePin:    (pin)             => set({ activePin: pin }),
  clearActivePin:  ()                => set({ activePin: null }),
  setUserLocation: (lat, lon, acc)   => set({ userLat: lat, userLon: lon, userAccuracy: acc ?? null }),
  clearUserLocation: ()              => set({ userLat: null, userLon: null, userAccuracy: null }),
  toggleRadar:     ()                => set((s) => ({ radarVisible: !s.radarVisible })),
  setRadarVisible: (v)               => set({ radarVisible: v }),
}));
